import * as React from "react";

import { navigateTo } from "gatsby-link";

import PlatformSelector from "./PlatformSelector/PlatformSelector";
import DocFolderCell from "./DocFolderCell/DocFolderCell";
import DocFileCell from "./DocFileCell";

const SCROLL_STORAGE_KEY: string = "blockv-devportal-docnavigator-scroll-y";

function isSameDoc(doc1, doc2) {
	return (
		// note: i don't think we need to check all of this
		// doc1.frontmatter.category === doc2.frontmatter.category &&
		// doc1.frontmatter.version === doc2.frontmatter.version &&
		// doc1.frontmatter.platform === doc2.frontmatter.platform &&
		doc1.frontmatter.path === doc2.frontmatter.path
	);
}

interface DocNavigatorProps {
	otherDocs: Array<{
		frontmatter: {
			path: string;
			title: string;
			category: string;
			platform: string;
			group: string;
			version: string;
		};
	}>;
	locationPath: string;
	groups: Array<{
		id: string;
		title: string;
	}>;
	shouldShowPlatforms: boolean;
	selectedDoc: {
		frontmatter: {
			path: string;
			title: string;
			category: string;
			platform: string;
			group: string;
			version: string;
		};
	};
	generateDocUrl: (docFrontmatter: any) => string;
	style?: any;
	isInDrawer?: boolean; // whether or not this DocNavigator is loading inside the mobile Drawer
	closeDrawer?(): any;
}

class DocNavigator extends React.Component<DocNavigatorProps, any> {
	private el: any;

	// persist and read scroll location on mount/unmount

	componentDidMount() {
		const scrollY = sessionStorage.getItem(SCROLL_STORAGE_KEY);
		sessionStorage.removeItem(SCROLL_STORAGE_KEY);

		this.el.scrollTo(0, scrollY);
	}

	componentWillUnmount() {
		sessionStorage.setItem(SCROLL_STORAGE_KEY, this.el.scrollTop);
	}

	navigateTo = (platform, keepDrawerOpen = false) => {
		navigateTo(`/docs/reference/v1/${platform}/getting-started`);

		// When we are inside of the Mobile drawer, close the drawer after navigating
		if (this.props.isInDrawer && !keepDrawerOpen) {
			setTimeout(() => this.props.closeDrawer(), 0); // timeout needed for CSS transition purposes
		}
	};

	render() {
		const props = this.props;

		return (
			<div
				ref={el => {
					this.el = el;
				}}
				style={{
					width: 245,
					backgroundColor: "white",
					overflowY: "scroll",
					paddingTop: 60,
					position: "fixed",
					...(props.style || {}),
				}}
			>
				<div
					style={{
						position: "fixed",
						top: props.isInDrawer ? 0 : "5rem",
						left: 0,
						backgroundColor: "rgb(68, 90, 100)",
						display: "flex",
						flexDirection: "row",
						padding: "0 1.61rem",
						height: "60px",
						width: 245,
					}}
				>
					{!this.props.shouldShowPlatforms ? null : (
						<PlatformSelector
							value={props.locationPath.split("/")[4]}
							onChangeValue={this.navigateTo}
						/>
					)}
				</div>

				<div
					style={{
						marginTop: "2em",
					}}
				>
					{props.groups.map(group => {
						const docs = props.otherDocs.filter(d => d.frontmatter.group === group.id);

						// note: this hides groups that do not contain any docs
						// so the ui does not display empty categories
						if (docs.length === 0) {
							return null;
						}

						const docCells = docs.map(doc => {
							const frontmatter = doc.frontmatter;

							const docUrl: string = this.props.generateDocUrl(frontmatter);

							return (
								<DocFileCell
									key={docUrl}
									title={frontmatter.title}
									link={docUrl}
									isSelected={isSameDoc(props.selectedDoc, doc)}
									isInDrawer={props.isInDrawer}
									closeDrawer={props.closeDrawer}
								/>
							);
						});

						return (
							<DocFolderCell key={group.id} title={group.title}>
								{docCells}
							</DocFolderCell>
						);
					})}
				</div>
			</div>
		);
	}
}

export default DocNavigator;



// WEBPACK FOOTER //
// ./src/components/DocNavigator.tsx